import { Mail } from "lucide-react";
import { CopyCommand } from "./CopyCommand";

const Footer = () => (
    <footer data-testid="footer" className="border-t border-[#262626]">
        <div className="mx-auto max-w-6xl px-4 py-24 text-center sm:px-6 sm:py-32">
            <p className="font-mono text-xs uppercase tracking-[0.4em] text-neutral-500">
                Let's build something
            </p>
            <h2
                data-testid="footer-headline"
                className="mt-4 text-4xl font-semibold tracking-tight text-neutral-50 sm:text-5xl lg:text-6xl"
            >
                Remembered<span className="text-green-400">.</span>
            </h2>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
                <CopyCommand testid="footer-copy-install-button" />
                <a
                    href="mailto:hello@remembered.sh"
                    data-testid="footer-email-link"
                    className="inline-flex items-center gap-2 border border-[#262626] bg-[#0a0a0a] px-5 py-3 font-mono text-sm text-neutral-200 transition-colors duration-200 hover:border-green-400/60 hover:text-green-400"
                >
                    <Mail className="h-4 w-4 text-neutral-500" />
                    hello@remembered.sh
                </a>
            </div>
        </div>
        <div className="border-t border-[#262626]">
            <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 font-mono text-[11px] text-neutral-600 sm:flex-row sm:px-6">
                <span data-testid="footer-brand">
                    remembered<span className="text-green-400">.sh</span> — procedural memory for AI agents
                </span>
                <span>© {new Date().getFullYear()} remembered.sh</span>
            </div>
        </div>
    </footer>
);

export default Footer;
